import { COVERABLE_CODE } from '../../../constants/coverable';

const IS_OPC_ADD_AVAILABLE = true;
const IS_OPC_EDIT_AVAILABLE = false;
const IS_OPC_REMOVE_AVAILABLE = false;

const {
    house,
    prhHolidayHome,
    privateContent,
    youthContent,
    travelHousehold,
    travelIndividual,
    car,
    accident,
    childAccident,
    youngAccident,
    crossAccident,
    dog,
    cat
} = COVERABLE_CODE;

const OPC_ADD_LOBS = [
    house,
    prhHolidayHome,
    privateContent,
    youthContent,
    travelHousehold,
    travelIndividual,
    car,
    accident,
    childAccident,
    youngAccident,
    crossAccident,
    dog,
    cat
];

export { IS_OPC_ADD_AVAILABLE, IS_OPC_EDIT_AVAILABLE, IS_OPC_REMOVE_AVAILABLE, OPC_ADD_LOBS };
